import React, {useState, useEffect, useRef} from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { notification, Skeleton, Modal } from "antd";
import { homeSelector } from "redux/selectors/homeSelector";
import moment from "moment";
import IconLogo from "images/logo-sidebar.svg";
import { CloseCircleFilled } from "@ant-design/icons";
import clsx from "clsx";
import httpClient from "../../api/module/httpClient";  

import "./style.scss";
import { CustomButton } from "components";


const ReferencePage = ({ userProfile }) => {
    const [dataRewardful, setDataRewardful] = useState(null);
    const [popUp, setPopUp] = useState(false);
    const [dashboard,setDashbooard] = useState(null);
    const [updateData, setUpdateData] = useState(false);
    const [loading, setLoading] = useState(false);
    const [copied, setCopied] = useState(false);
    const containerRewardful1 = useRef(null);
    const containerRewardful = useRef(null);

    const getDataRefernceLink = async (paypalEmail='') => {
        try {
            const { data } = await httpClient.get(`private/getlinkreferencedrewardful`, {
                params:{ paypalEmail }
            });
            if(!(data?.msg === 'emailRe or paypalEmail not found')){
                setDataRewardful(data)
                setDashbooard(true)
            }else{
                setDashbooard(false)
            }
            if(data?.msg2){
                notification.success({ message: "Updated!", description: "" });
            }
            setLoading(false)
        } catch (error) {
            setLoading(false)
            notification.error({ message: "Error", description: "Try again." });
        }
    }

    const contactEnpoint = async (object) => {
        try {
            const data = await httpClient.post(`private/sendEmailContact`, object);
           
            if(data?.status){
                notification.success({ message: "Sended!", description: "" });
                setLoading(false)
                setPopUp(false)
            }
        } catch (error) {
            setLoading(false)
            notification.error({ message: "Error", description: "Try again." });
        }
    }

    useEffect(() => {
        if(containerRewardful1.current){
            containerRewardful1.current.scroll(0,0)
        }
        if(containerRewardful.current){
            containerRewardful.current.scroll(0,0)
        }
    },[dashboard])

    useEffect(() => {
        getDataRefernceLink();
    }, []);

    const handleCopy = () => {
        navigator.clipboard.writeText(dataRewardful?.link);
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
    };

    const updateProfile = async (e) => {
        setLoading(true)
        e.preventDefault();
        e.stopPropagation();
        const formData = new FormData(e.target);
        const datos = {};
        for (const [clave, valor] of formData.entries()) {
            datos[clave] = valor;
        }
        getDataRefernceLink(datos.paypalEmail);
    }
    
    const sendContact = async (e) => {
        setLoading(true)
        e.preventDefault();
        e.stopPropagation();
        const formData = new FormData(e.target);
        const datos = {};
        for (const [clave, valor] of formData.entries()) {
            datos[clave] = valor;
        }
        contactEnpoint(datos);
    }

    const goToRewardful = async () => {
        try{
            const { data } = await httpClient.get(`private/getUrlDashboardRewardful`, {
                params:{ id: dataRewardful?.affiliate?.id }
            });
            if(data?.linkDashboard){
                window.open(data?.linkDashboard, '_blank');
            }else{
                notification.error({ message: "Error", description: 'Try Again' });    
            }
        }catch(er){
            notification.error({ message: "Error", description: 'Try Again' });
        }
    }

    return (<>
        {dashboard === false ? <div className="w-full" id="artifacts-component-root-react" ref={containerRewardful1}>
            <div className="max-w-4xl mx-auto px-4 py-8">
                <div className="text-center mb-12">
                    <h1 className="text-3xl font-bold mb-4">Affiliate Program</h1>
                    <p className="text-xl text-gray-600">Share our product and earn rewards!</p>
                </div>
                
                <div className="mb-16">
                    <h2 className="text-2xl font-bold mb-6 text-center">Why Join Our Affiliate Program?</h2>
                    <div className="grid md:grid-cols-3 gap-8">
                        <div className="bg-white p-6 rounded-lg shadow-md">
                        <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center mb-4">
                            <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 text-blue-600" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg>
                        </div>
                        <h3 className="text-lg font-semibold mb-2">Generous Commissions</h3>
                        <p className="text-gray-600">Earn 20% commission on every new customer you refer for their first year subscription.</p>
                        </div>
                        
                        <div className="bg-white p-6 rounded-lg shadow-md">
                        <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center mb-4">
                            <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 text-green-600" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg>
                        </div>
                        <h3 className="text-lg font-semibold mb-2">Easy to Join &amp; Use</h3>
                        <p className="text-gray-600">Simple sign-up process with instant approval. Get your unique affiliate link in seconds.</p>
                        </div>
                        
                        <div className="bg-white p-6 rounded-lg shadow-md">
                        <div className="w-12 h-12 bg-purple-100 rounded-full flex items-center justify-center mb-4">
                            <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 text-purple-600" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"></path></svg>
                        </div>
                        <h3 className="text-lg font-semibold mb-2">90-Day Conversion Window</h3>
                        <p className="text-gray-600">Generous 90-day cookie duration ensures you get credit even if they sign up later.</p>
                        </div>
                    </div>
                </div>
                
                <div className="mb-16">
                    <h2 className="text-2xl font-bold mb-6 text-center">How It Works</h2>
                    <div className="grid md:grid-cols-4 gap-4">
                        <div className="text-center">
                        <div className="w-12 h-12 bg-gray-200 rounded-full flex items-center justify-center mx-auto mb-3">
                            <span className="text-xl font-bold">1</span>
                        </div>
                        <h3 className="font-semibold mb-2">Sign Up</h3>
                        <p className="text-sm text-gray-600">Complete the form below to join our affiliate program</p>
                        </div>
                        
                        <div className="text-center">
                        <div className="w-12 h-12 bg-gray-200 rounded-full flex items-center justify-center mx-auto mb-3">
                            <span className="text-xl font-bold">2</span>
                        </div>
                        <h3 className="font-semibold mb-2">Get Your Link</h3>
                        <p className="text-sm text-gray-600">Receive your unique affiliate link instantly</p>
                        </div>
                        
                        <div className="text-center">
                        <div className="w-12 h-12 bg-gray-200 rounded-full flex items-center justify-center mx-auto mb-3">
                            <span className="text-xl font-bold">3</span>
                        </div>
                        <h3 className="font-semibold mb-2">Share &amp; Promote</h3>
                        <p className="text-sm text-gray-600">Share your link with your audience</p>
                        </div>
                        
                        <div className="text-center">
                        <div className="w-12 h-12 bg-gray-200 rounded-full flex items-center justify-center mx-auto mb-3">
                            <span className="text-xl font-bold">4</span>
                        </div>
                        <h3 className="font-semibold mb-2">Earn Rewards</h3>
                        <p className="text-sm text-gray-600">Get paid monthly via PayPal</p>
                        </div>
                    </div>
                </div>
                
                <div className="mb-16">
                    <h2 className="text-2xl font-bold mb-6 text-center">Join Our Affiliate Program</h2>
                    <div className="bg-white p-6 rounded-lg shadow-md max-w-md mx-auto">
                        <form className="space-y-4" onSubmit={(e) => updateProfile(e)}>
                            <div>
                                <label className="block text-sm font-medium text-gray-700">Your Name</label>
                                <input 
                                    required 
                                    readOnly 
                                    className="mt-1 block w-full px-3 py-2 bg-gray-100 border border-gray-300 rounded-md shadow-sm" 
                                    type="text" 
                                    value={userProfile?.firstName + ' ' + userProfile?.lastName} 
                                    name="name"
                                />
                                <p className="mt-1 text-xs text-gray-500" style={{marginTop:'0px', marginBottom:'30px'}}>Pre-filled from your account</p>
                            </div>
                            
                            <div>
                                <label className="block text-sm font-medium text-gray-700">Account Email</label>
                                <input 
                                    required 
                                    readOnly 
                                    className="mt-1 block w-full px-3 py-2 bg-gray-100 border border-gray-300 rounded-md shadow-sm" 
                                    type="email" 
                                    value={userProfile?.email} 
                                    name="accountEmail"
                                />
                                <p className="mt-1 text-xs text-gray-500" style={{marginTop:'0px', marginBottom:'30px'}}>Pre-filled from your account</p>
                            </div>
                            
                            <div>
                                <label className="block text-sm font-medium text-gray-700">PayPal Email</label>
                                <input 
                                    required 
                                    className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500" 
                                    placeholder="Your PayPal email address for receiving payments" 
                                    type="email" 
                                    name="paypalEmail"
                                    defaultValue={dataRewardful?.affiliate?.paypal_email}
                                />
                                <p className="mt-1 text-xs text-gray-500" style={{marginTop:'0px', marginBottom:'30px'}}>We currently only process affiliate payments via PayPal</p>
                            </div>
                            
                            <div className="pt-2">
                                <button
                                    type="submit" 
                                    disabled={loading}
                                    style={{cursor:'pointer'}}
                                    className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                                >
                                    {loading && <div className="custom-loader"></div>}
                                    <span>{loading ? 'Generating My Affiliate Link...' : 'Generate My Affiliate Link'}</span>
                                </button>
                            </div>
                        </form>
                    </div>
                </div>

                <div className="mb-16">
                    <h2 className="text-2xl font-bold mb-6 text-center">Terms &amp; Conditions</h2>
                    <div className="bg-white p-6 rounded-lg shadow-md">
                        <div className="space-y-4">
                        <div>
                            <h3 className="font-semibold">Commission Structure</h3>
                            <p className="text-gray-600">You'll earn 20% commission on every new customer's subscription for their first year.</p>
                        </div>
                        
                        <div>
                            <h3 className="font-semibold">Payment Terms</h3>
                            <p className="text-gray-600">Payments are processed for earnings over $150 via PayPal.</p>
                        </div>
                        
                        <div>
                            <h3 className="font-semibold">Cookie Duration</h3>
                            <p className="text-gray-600">We offer a 90-day cookie duration, ensuring you get credit for referrals even if they don't sign up immediately.</p>
                        </div>
                        
                        <div>
                            <h3 className="font-semibold">Prohibited Activities</h3>
                            <p className="text-gray-600">Spamming, false advertising, and bidding on our brand terms in paid search are not permitted.</p>
                        </div>
                        
                        <div>
                            <h3 className="font-semibold">Program Changes</h3>
                            <p className="text-gray-600">We reserve the right to modify the affiliate program terms with 30 days notice.</p>
                        </div>
                        </div>
                        
                        <p className="mt-4 text-sm text-gray-500">
                        By joining our affiliate program, you agree to these terms and conditions. For the complete terms, please <a href="#" className="text-blue-600 hover:underline">click here</a>.
                        </p>
                    </div>
                </div>
                
                <div className="mt-16">
                <h2 className="text-2xl font-bold mb-6 text-center">Frequently Asked Questions</h2>
                <div className="bg-white p-6 rounded-lg shadow-md">
                    <div className="space-y-6">
                    <div>
                        <h3 className="font-semibold">How soon will I get paid?</h3>
                        <p className="text-gray-600">We process payments once your earnings exceed the $150 threshold.</p>
                    </div>
                    
                    <div>
                        <h3 className="font-semibold">Is there a minimum payout threshold?</h3>
                        <p className="text-gray-600">Yes, you need to earn at least $150 to receive a payout.</p>
                    </div>
                    
                    <div>
                        <h3 className="font-semibold">How do I track my referrals and earnings?</h3>
                        <p className="text-gray-600">You'll have access to a dashboard showing your referrals, earnings, and payment history.</p>
                    </div>
                    
                    <div>
                        <h3 className="font-semibold">Can I promote your products on social media?</h3>
                        <p className="text-gray-600">Absolutely! Social media, blogs, email newsletters, and websites are all great ways to share your affiliate link.</p>
                    </div>
                    
                    <div>
                        <h3 className="font-semibold">What happens if I change my PayPal email?</h3>
                        <p className="text-gray-600">You can update your PayPal email in your affiliate dashboard at any time.</p>
                    </div>
                    </div>
                </div>
                </div>
            </div>
        </div> : dashboard === true ? <div className="min-h-full w-full" id="artifacts-component-root-react-dashboard" ref={containerRewardful}>
            <div className="max-w-4xl mx-auto px-4 py-8">
                <div className="mb-8">
                <h1 className="text-3xl font-bold mb-2">Your Affiliate Dashboard</h1>
                <p className="text-gray-600">Welcome back! Here's everything you need to manage your affiliate account.</p>
                </div>

                <div style={{marginBottom:'25px', gap: '15px', display:'flex', flexDirection:'row', flexWrap:'wrap', justifyContent:'space-between'}}>
                    <div style={{width:'100%', display: 'flex', flexDirection: 'column'}} className="bg-white p-6 rounded-lg shadow-md flex flex-col items-center justify-center text-center">
                        <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center mb-3">
                            <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 text-blue-600" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 10V3L4 14h7v7l9-11h-7z"></path></svg>
                        </div>
                        <h3 className="font-semibold mb-2">Your Affiliate Link</h3>
                        <div className="flex w-full mt-2" style={{maxWidth:'800px', width:'100%'}}>
                            <input
                                readOnly={!dataRewardful?.link}
                                style={{width:'calc(100% - 80px)', padding:'8px'}}
                                className="flex-grow text-sm px-2 py-1 border border-gray-300 rounded-l-md"
                                type="text"
                                value={dataRewardful?.link}
                            />
                            <button
                                onClick={handleCopy}
                                style={{padding:'8px'}}
                                className="px-3 py-1 border border-l-0 border-gray-300 rounded-r-md bg-gray-100 hover:bg-gray-200"
                            >
                                {copied ? 'Copied!' : 'Copy'}
                            </button>
                        </div>
                    </div>

                    <div className="w-card-performance bg-white p-6 rounded-lg shadow-md flex flex-col items-center justify-center text-center">
                        <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center mb-3">
                            <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 text-green-600" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"></path></svg>
                        </div>
                        <h3 className="font-semibold mb-2">View Performance</h3>
                        <p className="text-sm text-gray-600 mb-3">Check your referrals and earnings</p>
                        <a
                            href="#"
                            rel="noopener noreferrer"
                            onClick={() => goToRewardful()}
                            className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 text-sm"
                        >Go to Rewardful</a>
                    </div>

                    <div className="w-card-performance bg-white p-6 rounded-lg shadow-md flex flex-col items-center justify-center text-center">
                        <div className="w-12 h-12 bg-purple-100 rounded-full flex items-center justify-center mb-3">
                            <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 text-purple-600" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg>
                        </div>
                        <h3 className="font-semibold mb-2">Get Support</h3>
                        <p className="text-sm text-gray-600 mb-3">Questions about the affiliate program?</p>
                        <a
                            href="#"
                            className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 text-sm"
                            onClick={() => setPopUp(true)}
                        >Contact Us</a>
                    </div>

                    <div className="bg-white p-6 rounded-lg shadow-md mb-8" style={{width:'100%'}}>
                        <h2 className="text-xl font-bold mb-6" style={{paddingBottom:'15px'}}>Dashboard</h2>
                        <div style={{display:'flex', flexDirection:'row', flexWrap:'wrap', justifyContent:'space-around', gap:'20px'}}>
                            <div className="stats-card">
                                <div className="flex items-center justify-center mb-2" style={{position:'absolute', left: '10px', top: '10px'}}>
                                    <div className="container-bg-svg w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-users h-5 w-5 text-blue-600"><path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"></path><circle cx="9" cy="7" r="4"></circle><path d="M22 21v-2a4 4 0 0 0-3-3.87"></path><path d="M16 3.13a4 4 0 0 1 0 7.75"></path></svg>
                                    </div>
                                </div>
                                <div className="text-center">
                                    <p className="text-3xl font-bold text-gray-900" style={{marginBottom:'5px'}}>{dataRewardful?.affiliate?.visitors || 0}</p>
                                    <p className="text-sm text-gray-600" style={{marginBottom:'5px', marginTop:'10px'}}>Total Visitors</p>
                                </div>
                            </div>
                            
                            <div className="stats-card">
                                <div className="flex items-center justify-center mb-2" style={{position:'absolute', left: '10px', top: '10px'}}>
                                    <div className="container-bg-svg w-10 h-10 bg-green-100 rounded-full flex items-center justify-center">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-user-plus h-5 w-5 text-green-600"><path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"></path><circle cx="9" cy="7" r="4"></circle><line x1="19" x2="19" y1="8" y2="14"></line><line x1="22" x2="16" y1="11" y2="11"></line></svg>                                
                                    </div>
                                </div>
                                <div className="text-center">
                                    <p className="text-3xl font-bold text-gray-900" style={{marginBottom:'5px'}}>{dataRewardful?.affiliate?.leads || 0}</p>
                                    <p className="text-sm text-gray-600" style={{marginBottom:'5px', marginTop:'10px'}}>Total Leads</p>
                                </div>
                            </div>
                            
                            <div className="stats-card">
                                <div className="flex items-center justify-center mb-2" style={{position:'absolute', left: '10px', top: '10px'}}>
                                    <div className="container-bg-svg w-10 h-10 bg-purple-100 rounded-full flex items-center justify-center">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-target h-5 w-5 text-purple-600"><circle cx="12" cy="12" r="10"></circle><circle cx="12" cy="12" r="6"></circle><circle cx="12" cy="12" r="2"></circle></svg>                                
                                    </div>
                                </div>
                                <div className="text-center">
                                    <p className="text-3xl font-bold text-gray-900" style={{marginBottom:'5px'}}>{dataRewardful?.affiliate?.conversions || 0}</p>
                                    <p className="text-sm text-gray-600" style={{marginBottom:'5px', marginTop:'10px'}}>Conversions</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {!updateData ? <div className="bg-white p-6 rounded-lg shadow-md mb-8" style={{marginBottom:'30px'}}>
                    <h2 className="text-xl font-bold mb-4">Your Account Information</h2>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <div>
                            <h3 className="text-sm font-medium text-gray-500">Name</h3>
                            <p className="text-gray-800">{userProfile?.firstName} {userProfile?.lastName}</p>
                        </div>
                        <div>
                            <h3 className="text-sm font-medium text-gray-500">Account Email</h3>
                            <p className="text-gray-800">{userProfile?.email}</p>
                        </div>
                        <div>
                            <h3 className="text-sm font-medium text-gray-500">PayPal Email</h3>
                            {dataRewardful?.affiliate?.paypal_email ? <p className="text-gray-800">{dataRewardful?.affiliate?.paypal_email}</p> : <Skeleton style={{marginTop:'20px'}} width={50} height={20} />}
                        </div>
                        <div>
                            <h3 className="text-sm font-medium text-gray-500">Joined Date</h3>
                            {dataRewardful?.affiliate?.created_at ? <p className="text-gray-800">{moment(dataRewardful?.affiliate?.created_at).format("MMMM D, YYYY")}</p> : <Skeleton style={{marginTop:'20px'}} width={50} height={20} />}
                        </div>
                    </div>
                    <div className="mt-4 pt-4 border-t border-gray-200">
                        <a 
                            href="#" 
                            className="text-blue-600 hover:underline text-sm" 
                            onClick={() => setUpdateData(true)}
                        >Need to update your information?</a>
                    </div>
                </div> : <div>
                    <div className="bg-white p-6 rounded-lg shadow-md max-w-md mx-auto" style={{marginBottom:'30px'}}>
                        <form className="space-y-4" onSubmit={(e) => updateProfile(e)}>
                            <div>
                                <label className="block text-sm font-medium text-gray-700">Your Name</label>
                                <input 
                                    required 
                                    readOnly 
                                    className="mt-1 block w-full px-3 py-2 bg-gray-100 border border-gray-300 rounded-md shadow-sm" 
                                    type="text" 
                                    value={userProfile?.firstName + ' ' + userProfile?.lastName} 
                                    name="name"
                                />
                                <p className="mt-1 text-xs text-gray-500" style={{marginTop:'0px', marginBottom:'30px'}}>Pre-filled from your account</p>
                            </div>
                            
                            <div>
                                <label className="block text-sm font-medium text-gray-700">Account Email</label>
                                <input 
                                    required 
                                    readOnly 
                                    className="mt-1 block w-full px-3 py-2 bg-gray-100 border border-gray-300 rounded-md shadow-sm" 
                                    type="email" 
                                    value={userProfile?.email}
                                    name="accountEmail"
                                />
                                <p className="mt-1 text-xs text-gray-500" style={{marginTop:'0px', marginBottom:'30px'}}>Pre-filled from your account</p>
                            </div>
                            
                            <div>
                                <label className="block text-sm font-medium text-gray-700">PayPal Email</label>
                                <input 
                                    required 
                                    className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500" 
                                    placeholder="Your PayPal email address for receiving payments" 
                                    type="email" 
                                    name="paypalEmail"
                                    defaultValue={dataRewardful?.affiliate?.paypal_email}
                                />
                                <p className="mt-1 text-xs text-gray-500" style={{marginTop:'0px', marginBottom:'30px'}}>We currently only process affiliate payments via PayPal</p>
                            </div>
                            
                            <div className="pt-2" style={{display:'flex',flexDirection:'row',gap:'20px'}}>
                                <button 
                                    onClick={() => setUpdateData(false)}
                                    type="submit" 
                                    style={{cursor:'pointer'}}
                                    className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                                >Cancel</button>
                                <button
                                    type="submit" 
                                    disabled={loading}
                                    style={{cursor:'pointer', backgroundColor:'#fe5621', color: 'white'}}
                                    className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                                >
                                    {loading && <div className="custom-loader"></div>}
                                    <span>{loading ? 'Updating...' : 'Update'}</span>
                                </button>
                            </div>
                        </form>
                    </div>
                </div>}

                <div className="bg-white p-6 rounded-lg shadow-md">
                <h2 className="text-xl font-bold mb-4">Program Reminders</h2>
                <ul className="space-y-3">
                    <li className="flex items-start" style={{ listStyle: 'none',display: 'flex',flexDirection: 'row', marginTop:'20px', marginBottom:'20px'}}>
                        <svg class="h-5 w-5 text-green-500 mr-2 mt-0.5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"><path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd"></path></svg>
                        <p className="text-gray-700" style={{margin: '0px', width: 'calc(100% - 60px)'}}>
                            You earn <strong>20%</strong> commission on all referrals for their first year
                        </p>
                    </li>
                    <li className="flex items-start" style={{ listStyle: 'none',display: 'flex',flexDirection: 'row', marginTop:'20px', marginBottom:'20px'}}>
                        <svg class="h-5 w-5 text-green-500 mr-2 mt-0.5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"><path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd"></path></svg>
                        <p className="text-gray-700" style={{margin: '0px', width: 'calc(100% - 60px)'}}>
                            Your referral link has a <strong>90-day</strong> cookie duration
                        </p>
                    </li>
                    <li className="flex items-start" style={{ listStyle: 'none',display: 'flex',flexDirection: 'row', marginTop:'20px', marginBottom:'20px'}}>
                        <svg class="h-5 w-5 text-green-500 mr-2 mt-0.5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"><path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd"></path></svg>
                        <p className="text-gray-700" style={{margin: '0px', width: 'calc(100% - 60px)'}}>
                            Payments are processed via PayPal once your earnings exceed <strong>$150</strong>
                        </p>
                    </li>
                    <li className="flex items-start" style={{ listStyle: 'none',display: 'flex',flexDirection: 'row', marginTop:'20px', marginBottom:'20px'}}>
                        <svg class="h-5 w-5 text-green-500 mr-2 mt-0.5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"><path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd"></path></svg>
                        <p className="text-gray-700" style={{margin: '0px', width: 'calc(100% - 60px)'}}>
                            For detailed analytics and performance data, visit your{' '}
                            <a
                                href="#"
                                rel="noopener noreferrer"
                                onClick={() => goToRewardful()}
                                className="text-blue-600 hover:underline"
                            >Rewardful dashboard</a>
                        </p>
                    </li>
                    <li className="flex items-start" style={{ listStyle: 'none',display: 'flex',flexDirection: 'row', marginTop:'20px', marginBottom:'20px'}}>
                        <svg class="h-5 w-5 text-green-500 mr-2 mt-0.5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"><path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd"></path></svg>
                        <p className="text-gray-700" style={{margin: '0px', width: 'calc(100% - 60px)'}}>
                            If you have any questions or queries,  
                            <a
                                href="#"
                                rel="noopener noreferrer"
                                onClick={() => setPopUp(true)}
                                className="text-blue-600 hover:underline"
                                style={{marginLeft:'5px'}}
                            >contact us</a>
                        </p>
                    </li>
                </ul>
                </div>
            </div>
        </div> : <div style={{padding:'20px'}}>
            <Skeleton style={{marginTop:'20px'}} width={500} height={100} />
            <Skeleton style={{marginTop:'20px'}} width={500} height={100} />
            <Skeleton style={{marginTop:'20px'}} width={500} height={100} />
        </div>}
        <Modal
            className={clsx("custom-modal")}
            wrapClassName={clsx("custom-modal-wrap")}
            centered
            onCancel={(e) => {e.preventDefault(); e.stopPropagation(); setPopUp(false);}}
            visible={popUp}
            closable={true}
            footer={[]}
            width="600px"
            style={{ top: "40px" }}
            title={
            <div
                className="custom-modal-title"
                style={{paddingLeft: "20px",paddingRight: "20px",display: "flex",justifyContent: "center",alignItems: "start"}}
            >
                <div className="custom-modal-logo"> <img src={IconLogo} alt="custom-logo" /> </div>
            </div>
            }
            closeIcon={<CloseCircleFilled className="custom-modal-close" />}
        >
            <div className="container-contact-reference" style={{height:'auto'}}>
                <form className="space-y-4" onSubmit={(e) => sendContact(e)}>
                    <div>
                        <label className="block text-sm font-medium text-gray-700">Your Name</label>
                        <input 
                            required 
                            readOnly 
                            className="mt-1 block w-full px-3 py-2 bg-gray-100 border border-gray-300 rounded-md shadow-sm" 
                            type="text" 
                            value={userProfile?.firstName + ' ' + userProfile?.lastName} 
                            name="name"
                        />
                        <p className="mt-1 text-xs text-gray-500" style={{marginTop:'0px', marginBottom:'30px'}}>Pre-filled from your account</p>
                    </div>
                    
                    <div>
                        <label className="block text-sm font-medium text-gray-700">Account Email</label>
                        <input 
                            required 
                            readOnly 
                            className="mt-1 block w-full px-3 py-2 bg-gray-100 border border-gray-300 rounded-md shadow-sm" 
                            type="email" 
                            value={userProfile?.email}
                            name="email"
                        />
                        <p className="mt-1 text-xs text-gray-500" style={{marginTop:'0px', marginBottom:'30px'}}>Pre-filled from your account</p>
                    </div>
                    
                    <div>
                        <label className="block text-sm font-medium text-gray-700">Message</label>
                        <textarea
                            required 
                            className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"  
                            name="message"
                        />
                    </div>
                    
                    <div className="pt-2" style={{display:'flex',flexDirection:'row',gap:'20px', marginTop: '20px'}}>
                        {/* <CustomButton
                            text="Cancel"
                            onClick={() => setUpdateData(false)}
                            style={{width:'100%'}}
                            size="sm"
                            type="primary"
                        /> */}
                        <div className="button-special-form" onClick={() => setUpdateData(false)}>Cancel</div>
                        <button
                            type="submit" 
                            disabled={loading}
                        >
                            {loading && <div className="custom-loader"></div>}
                            <span>{loading ? 'Sending...' : 'Send'}</span>
                        </button>
                    </div>
                </form>
                {/* <iframe src="https://dd4794bf.sibforms.com/serve/MUIFAKYdoxzYtqNZT3vHkNU-B6om9e3-UIRdtjL1-m_GHg0QoZEC-S7fhD-TZT7h2RgmeCYk_xH_LiDE13hA0qYTgdTb1S28MI4ol1Q07skn1T2P_wB9sbq3FixmeuYCHwwrl3r73afk7s7WLTPEknQyn0moNXDjzllNKE18gwY0cVHturjuA2npzPbdLSk5RbHj3FP5G2lBsNTG" frameBorder="0" allowFullScreen style={{display: 'block',marginLeft: 'auto',marginRight: 'auto',maxWidth: '100%',width:'100%',height:'100%'}}></iframe> */}
            </div>
        </Modal>
    </>);
};

ReferencePage.propTypes = {
  title: PropTypes.string,
};

ReferencePage.defaultProps = {
  title: "",
};

const mapStateToProps = (state) => ({
    userProfile: homeSelector(state).userProfile,
});

const mapDispatchToProps = {

};

export default connect(mapStateToProps, mapDispatchToProps)(ReferencePage);